import './widget.css';
import API from '../../../../utils/API';
import { WIDGET_SIZE_TYPE } from '../../../../utils/constants'

const getStationURL = 'https://api.weather.gov/points/';
// when compiled based on environment
let environment = "cloud";
if(document.currentScript.src.includes("staging")) {
  environment = "staging";
};
if(document.currentScript.src.includes("staging2")) {
  environment = "staging2";
};
if(document.currentScript.src.includes("prod")) {
  environment = "prod";
};
if(document.currentScript.src.includes("dev") || document.currentScript.src.includes("local")|| document.currentScript.src.includes("192.168.7.209")) {
  environment = "dev";
};

const backEndGetIconsAPIAddr = `https://${environment}.screenbeam.com/api/signage/icons`;
const backEndGetAnalogClockFace = `https://${environment}.screenbeam.com/api/signage/analog-clock-face.svg`;
const backEndAPIAddrForCalendarIcs = `https://${environment}.screenbeam.com/api/signage/calendar-ics`;
/*
const testIP = '10.0.0.6';
const backEndGetIconsAPIAddr = `https://${testIP}:3001/api/signage/icons`;
const backEndGetAnalogClockFace = `https://${testIP}:3001/api/signage/analog-clock-face.svg`;
const backEndAPIAddrForCalendarIcs = `https://${testIP}:3001/api/signage/calendar-ics`;
*/
const getDateOptions = {
  timeZone: '',
  weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  //second: '2-digit',
  hour12: true
};
var getTimeOptions = {
  timeZone: '',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false
};
// Map digits to their names (this will be an array)
const digit_to_name = 'zero one two three four five six seven eight nine'.split(' ');
// Positions for the hours, minutes, and seconds
const digitalClockPositions = ['h1', 'h2', ':', 'm1', 'm2'];

const weather_units = {
  us: '°F',
  metric: '°C',
  uk: '°C',
  ca: '°C'
};

/**
 * weather widget function
 * @param {*} paramters 
 * @returns 
 */
export async function getWeatherWidget(paramters, widgetSizeType = WIDGET_SIZE_TYPE.SMALL) {
  console.log('*****************getWeatherWidget called with parameters:', paramters);
  try{
    let res = await getWeatherFromBackend(paramters.city, paramters.lat, paramters.lon);
    console.log('*****************getWeatherWidget called with parameters:', paramters, ' found weather info:', res);
    let weatherInfo = null;
    if(res && res.weather_info) {
      weatherInfo = res.weather_info;
    }

    if(weatherInfo && weatherInfo.current){
      let bgClass = 'weather-widget-bg';
      let bgShortForecastClass = 'weather-short-forecast-bg-day';
      let iconURL = '';
      let iconName = weatherInfo.current.icon_num;
      /**
       * Meteosource icon number: 0-25 day, 26-36 night
       * sometimes icon number < 26, but in fact it's night time, need to check current time with sunrise/sunset time
       */
      const hour = new Date().toLocaleString('en-US', { hour: '2-digit', hour12: false, timeZone: weatherInfo.timezone });
      iconURL = `${backEndGetIconsAPIAddr}/${iconName}.svg`;
      if(iconName >= 26 || 
        hour >= 18 || hour < 6)
      {
        bgClass = 'weather-widget-bg-night';
        bgShortForecastClass = 'weather-short-forecast-bg-night';
        //iconURL = `${backEndGetIconsAPIAddr}/${iconName}_night.svg`;
      }
            
      console.log(`********iconName:${iconName}******weatherInfo.iconURL:${iconURL}***weatherInfo. timezone:${weatherInfo.timezone}***hour=${hour}****`);

      let date = new Date();
      getDateOptions.timeZone = weatherInfo.timezone;
      let dateText = date.toLocaleString('en-US', getDateOptions);
      dateText = dateText.replace(/\s+at\s+/, " - ");

      return createModule(
        bgClass,
        bgShortForecastClass,
        paramters.city, // City
        dateText, // Date
        iconURL, // Icon URL
        `${weatherInfo.current?.temperature.toFixed(0)} ${weather_units[weatherInfo.units] ? weather_units[weatherInfo.units] : '°C'}`, // Temperature
        weatherInfo.current.summary ? weatherInfo.current.summary : '', // Short Forecast
		    widgetSizeType
      );
    }
  }catch(error){
    console.error('Error occurred while getting weather widget:', error);
  } 
  return createModule(
    'weather-widget-bg',
    'weather-short-forecast-bg-day',
    'Failed to get weather information.', // City
    '', // Date
    '', // Icon URL
    '', // Temperature
    '', // Short Forecast
    widgetSizeType
  );
}

export async function getWeatherWidgetOld(paramters) {
  console.log('*****************getWeatherWidget called with parameters:', paramters);
  return await getWeather(paramters.lat, paramters.lon)
  .then((res)=> {
      console.log('weathers:', res);
      let weatherInfo = null;
    if(res || res.periods || res.periods.length > 0) {
        weatherInfo = res.periods[0];
      }

    if(weatherInfo){
        let bgClass = 'weather-widget-bg';
        let iconURL = '';
        let iconName = new URL(weatherInfo.icon).pathname.split('/').filter(Boolean).pop();
        iconName = iconName.split(',')[0];
        // Check if the icon URL contains 'day' or 'night'
      if(weatherInfo.name && weatherInfo.name.includes('Night') ||
          weatherInfo.icon && weatherInfo.icon.includes('night')) {
          iconName += '_night';
          bgClass = 'weather-widget-bg-night';
        }

        iconURL = `${backEndGetIconsAPIAddr}/${iconName}.svg`;
        console.log(`********iconName:${iconName}******weatherInfo.iconURL:${iconURL}***weatherInfo. timezone:${res.timeZone}*******`);

        let date = new Date();
        getDateOptions.timeZone = res.timeZone;
        const dateText = date.toLocaleString('en-US', getDateOptions);

        return createModule(
          bgClass,
          paramters.city, // City
          dateText, // Date
          iconURL, // Icon URL
          `${weatherInfo.temperature}${weatherInfo.temperatureUnit}`, // Temperature
          weatherInfo.shortForecast // Short Forecast
        );
      }
      return;
    })
    .catch(error => console.error(error));
}

async function getWeather(lat, lon) {
  try {
    console.log(`*****************getWeather called with lat:${lat}  lon:${lon}`);

    //get the weather station by lat and lon
    const stationData = await getWeatherStation(lat, lon);
    console.log('******************getWeather called with stationData.properties.timeZone:', stationData.properties.timeZone);
    const forecastUrl = stationData.properties.forecast; // get weather forecast URL from station data

    //get the weather forecast from the URL
    const forecast = await getForecast(forecastUrl);
    return ({periods:forecast.properties.periods, timeZone: stationData.properties.timeZone}); // return the periods of the forecast
  } catch (error) {
    console.error('get weather failed:', error);
    throw error;
  }
}

async function getWeatherStation(lat, lon) {
  const response = await fetch(getStationURL + `${lat},${lon}`);
  if (!response.ok) throw new Error('getWeatherStation failed: ' + response.statusText);
  return await response.json();
}

async function getForecast(forecastUrl) {
  const response = await fetch(forecastUrl);
  if (!response.ok) throw new Error('getForecast failed: ' + response.statusText);
  return await response.json();
}

async function getWeatherFromBackend(city, lat, lon) {
  try {
    const res = await API.getWeatherInfo({ city, lat, lon, t: Date.now() });
    const data = res.data;
    if (data) {
      console.log('Weather data from backend:', data);
      return data;
    }
    return null;
  } catch (error) {
    console.error('get weather failed:', error);
    return null;
  }
}

function createModule(bgClass, bgShortForecastClass, cityText, dateText, iconURL, temperatureText, shortForecastText, widgetSize=WIDGET_SIZE_TYPE.SMALL) {
  if(widgetSize === WIDGET_SIZE_TYPE.SMALL){
    return `
      <div class="weather-widget ${bgClass}">
            <div class="weather-main-info">
              <div class="row location-info">
                <span class="location-city" id="weather-">${cityText}</span>
                <span class="location-date">${dateText}</span>
              </div>
              <div class="row weather-info">
                    <div class="weather-icon">
                      <img src="${iconURL}" alt="weather icon" class="weather-icon-${widgetSize}"/>
                    </div>
                  <div class="weather-temperature-${widgetSize}">${temperatureText}</div>
                  <div class="weather-short-forecast-${widgetSize} ${bgShortForecastClass}">${shortForecastText}</div>
              </div>
            </div>
      </div>
    `;
  }else if(widgetSize === WIDGET_SIZE_TYPE.MEDIUM){
    return `
      <div class="weather-widget ${bgClass}">
            <div class="weather-main-info-m">
              <div class="row weather-info-m">
                  <img src="${iconURL}" alt="weather icon" class="weather-icon-${widgetSize}"/>
              </div>
              <div class="weather-info-m">
                  <div class="weather-temperature-${widgetSize}">${temperatureText}</div>
                  <div class="weather-short-forecast-${widgetSize} ${bgShortForecastClass}">${shortForecastText}</div>
              </div>
              <div class="row location-info">
                  <span class="location-city" id="weather-">${cityText}</span>
                  <span class="location-date">${dateText}</span>
              </div>
            </div>
      </div>
    `;
  }else if(widgetSize === WIDGET_SIZE_TYPE.LARGE){
    return `
      <div class="weather-widget ${bgClass}">
            <div class="row weather-main-info-l">
             <div class="col-5 weather-info-l">
               <div class="weather-short-forecast-${widgetSize} ${bgShortForecastClass}">${shortForecastText}</div>
               <div class="weather-icon-container-l">
                  <img src="${iconURL}" alt="weather icon" class="weather-icon-${widgetSize}"/>
               </div>
             </div>
             <div class="col-7 location-info-l weather-border-line">
                  <span class="location-city-l" id="weather-">${cityText}</span>
                  <div class="weather-temperature-${widgetSize}">${temperatureText}</div>
                  <span class="location-date-l">${dateText}</span>
             </div>
            </div>
      </div>
    `;
  }
}

/**
 * Digital Clock widget function
 * @param {*} paramters 
 * @returns 
 */
export function getDigitalClockWidget(widgetName, widgetContainer, paramters)
{
  widgetContainer.appendChild(createDigitalClockMoudle(widgetName));
  updateDigitalClock(widgetName, paramters);
}
function createDigitalClockMoudle(widgetName)
{
  //div id=clock
  var divClock = document.createElement('div');
  divClock.setAttribute('id', 'clock');
  divClock.classList.add('digital-clock-widget');

  //div digits
  var divDigits = document.createElement('div');
  divDigits.classList.add('clock-main-info', 'digits');
  divClock.appendChild(divDigits);

  //div time hh:mm
  digitalClockPositions.forEach((type) =>{
    var timeDiv = document.createElement('div');
    timeDiv.setAttribute('id', widgetName + '-' + type);
    if(type == ':'){
      timeDiv.classList.add('dots');
    }
    else{
      for(var i=1; i<8; i++){
        var timeIconsDiv = document.createElement('span');
        timeIconsDiv.classList.add('d-' + i);
        timeDiv.appendChild(timeIconsDiv);
      }
    }
    divDigits.appendChild(timeDiv);
  });
  return divClock;
}

function updateDigitalClock(widgetName, paramters)
{
  let date = new Date();

  getTimeOptions.timeZone = paramters.timeZone;
  getTimeOptions.hour12 = paramters.format;

  var nowTime = date.toLocaleString('en-US', getTimeOptions);

  //update div time hh:mm
  digitalClockPositions.forEach((type, index) =>{
    if(type != ':'){
      var timeElement = document.getElementById(widgetName + '-' + type);
      //over old class
      if(timeElement){
        timeElement.setAttribute('class',  digit_to_name[nowTime[index]]);
      }
    }
  });
}

/**
 * Analog Clock widget function
 * @param {*} paramters 
 * @returns 
 */
export function getAnalogClockWidget(widgetName, widgetContainer, paramters) {
  widgetContainer.appendChild(createAnalogClockMoudle(widgetName));
  updateAnalogClock(widgetName, paramters);
}
function createAnalogClockMoudle(widgetName) {
  //div id=analog-clock
  var divClock = document.createElement('div');
  divClock.setAttribute('id', 'analog-clock');
  divClock.classList.add('analog-clock-widget');

  //div analog-clock-main-info
  var divMainInfo = document.createElement('div');
  divMainInfo.classList.add('analog-clock-main-info');
  divClock.appendChild(divMainInfo);

  //image clock face
  var imgClockFace = document.createElement('img');
  imgClockFace.setAttribute('src', backEndGetAnalogClockFace);
  divMainInfo.appendChild(imgClockFace);

  //div center dot
  var divCenterDot = document.createElement('div');
  divCenterDot.classList.add('center-dot');
  divMainInfo.appendChild(divCenterDot);

  //div hour-hand
  var divHourHand = document.createElement('div');
  divHourHand.setAttribute('id', widgetName + '-hour-hand');
  divHourHand.classList.add('hand', 'hour-hand');
  divMainInfo.appendChild(divHourHand);

  //div minute-hand
  var divMinuteHand = document.createElement('div');
  divMinuteHand.setAttribute('id', widgetName + '-minute-hand');
  divMinuteHand.classList.add('hand', 'minute-hand');
  divMainInfo.appendChild(divMinuteHand);

  //div second-hand
  var divSecondHand = document.createElement('div');
  divSecondHand.setAttribute('id', widgetName + '-second-hand');
  divSecondHand.classList.add('hand', 'second-hand');
  divMainInfo.appendChild(divSecondHand);

  return divClock;
}

export function updateAnalogClock(widgetName, paramters) {
  console.log(`updateAnalogClock called with widgetName: ${widgetName} and parameters: ${JSON.stringify(paramters)}`);
  const now = new Date();
  const timeStr = now.toLocaleString('en-US', { timeZone: paramters.timeZone });
  //console.log(` timeStr = ${timeStr}`);
  const currentDate = new Date(timeStr);
  //console.log(` ${currentDate}`);
  const hours = currentDate.getHours() % 12;
  const minutes = currentDate.getMinutes();
  const seconds = currentDate.getSeconds();

  const hourDegrees = (hours * 30) + (minutes * 0.5); // 360 / 12 = 30 degrees per hour, plus 0.5 degrees per minute
  const minuteDegrees = minutes * 6; // 360 / 60 = 6 degrees per minute
  const secondDegrees = seconds * 6; // 360 / 60 = 6 degrees per second

  /*
  document.getElementById(`${widgetName}-hour-hand`).querySelector('.hour-hand').style.transform = `rotate(${hourDegrees}deg)`;
  document.getElementById(`${widgetName}-minute-hand`).querySelector('.minute-hand').style.transform = `rotate(${minuteDegrees}deg)`;
  document.getElementById(`${widgetName}-second-hand`).querySelector('.second-hand').style.transform = `rotate(${secondDegrees}deg)`;
  */
  const hourHand = document.querySelector(`#${widgetName}-hour-hand`);
  if (hourHand) {
    hourHand.style.transform = `rotate(${hourDegrees}deg)`;
  }

  const minuteHand = document.querySelector(`#${widgetName}-minute-hand`);
  if (minuteHand) {
    minuteHand.style.transform = `rotate(${minuteDegrees}deg)`;
  }

  const secondHand = document.querySelector(`#${widgetName}-second-hand`);
  if (secondHand) {
    secondHand.style.transform = `rotate(${secondDegrees}deg)`;
  }
}


/**
 * Calendar widget function
 * @param {*} paramters 
 * @returns 
 */
export function getCalendarWidget(widgetName, widgetContainer, paramters){
  console.log("*********getCalendarWidget************")
  const timeZoneVar = paramters.timeZone;
  const now = new Date();
  const timeStr = now.toLocaleString('en-US', { timeZone: timeZoneVar });
  const currentDate = new Date(timeStr);
  console.log("currentDate = " + currentDate)


  const monthYear = now.toLocaleDateString('en-US', { timeZone: timeZoneVar, year: 'numeric', month: 'long'});
  console.log("month = " + monthYear)
  widgetContainer.innerHTML = createCalendarModule(widgetName, monthYear);

var testing = now.toLocaleDateString('en-US', { timeZone: timeZoneVar, year: 'numeric', month: 'long', weekday: 'long'});
  console.log("testing = " + testing);
  console.log("currentDate = " + currentDate);

  //Get days from previous month to display
  const prevMonthDays = getPrevMonthDays(currentDate, timeZoneVar);
  console.log("prev month days=" + prevMonthDays);

  // Get days in current month
  const currentMonthDays = getDaysInMonth(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1
  );

  // Get days from next month to display
  const nextMonthDays = 42 - (prevMonthDays + currentMonthDays); // 6 weeks

  // Create day elements
  createDayElements(widgetName, timeZoneVar, currentDate, prevMonthDays, currentMonthDays, nextMonthDays);

}
function getPrevMonthDays(date, timeZoneVar) {
  //Get the firstDay of currect month
  const firstDayIndex = new Date(date.getFullYear(), date.getMonth(), 1);
  return firstDayIndex.getDay();
}
function getDaysInMonth(year, month) {
  return new Date(year, month, 0).getDate();
}

function createCalendarModule(widgetName, monthYear)
{
  return `
  <div class="calendar-widget">
    <div class="calendar-main-info">
      <div class="calendar-header">
        <h2 class="month-year">${monthYear}</h2>
      </div>
      <div class="calendar-weekdays">
        <div class="red">Sun</div>
        <div>Mon</div>
        <div>Tue</div>
        <div>Wed</div>
        <div>Thu</div>
        <div>Fri</div>
        <div class="red">Sat</div>
      </div>
      <div id="${widgetName}-calendar-days" class="calendar-days"></div>
    </div>
  </div>
  `;
}
function createDayElements(widgetName, timeZoneVar, currentDate, prevMonthDays, currentMonthDays, nextMonthDays) {
  // Previous month days
  var prevMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() - 1,
    1
  );
  const timeStr = prevMonth.toLocaleString('en-US', { timeZone: timeZoneVar });
  prevMonth = new Date(timeStr);
  const prevMonthTotalDays = getDaysInMonth(
    prevMonth.getFullYear(),
    prevMonth.getMonth() + 1
  );
      console.log("*****prevMonthTotalDays=*****"+prevMonthTotalDays);
  var daysContainer = document.getElementById(`${widgetName}-calendar-days`);
         console.log("*****prevMonthTotalDays=**222222***"+prevMonthTotalDays);
  for (let i = prevMonthTotalDays - prevMonthDays + 1; i <= prevMonthTotalDays; i++) {
        console.log("*****prevMonthTotalDays=**33333***"+prevMonthTotalDays);
    daysContainer.appendChild(createDayElement(i, 'other-month'));
  }

  // Current month days
  for (let i = 1; i <= currentMonthDays; i++) {
    const isToday =
      i === currentDate.getDate() &&
      currentDate.getMonth() === currentDate.getMonth() &&
      currentDate.getFullYear() === currentDate.getFullYear();

    daysContainer.appendChild(createDayElement(i, isToday ? 'today' : ''));
  }

  // Next month days
  for (let i = 1; i <= nextMonthDays; i++) {
    daysContainer.appendChild(createDayElement(i, 'other-month'));
  }
}

function createDayElement(dayNum, className) {
  var dayElememnt = document.createElement('div');
  dayElememnt.classList.add('calendar-day');
  if (className) dayElememnt.classList.add(className);
  dayElememnt.textContent = dayNum;

  // Add click event
  /*dayElememnt.addEventListener('click', () => {
    document.querySelectorAll('.day.selected').forEach(el => {
      el.classList.remove('selected');
    });
    if (!dayElememnt.classList.contains('other-month')) {
      dayElememnt.classList.add('selected');
    }
  });*/
  return dayElememnt;
}

export async function fetchAndParseICS(paramters) {
  try {
    // Fetch the ICS file content from the provided URL
    const icsData = await fetchICSFile(paramters.calendarUrl);

    // Detect the source of the ICS file (Google or Outlook)
    const isGoogleCalendar = icsData.includes('PRODID:-//Google Inc//Google Calendar');

    // Parse ICS data and extract event information
    const events = parseICS(icsData, isGoogleCalendar);

    // Filter events for today
    const todayEvents = getEventsForToday(events, paramters.timeZone);
    const icsElements = createStyledDateElement(todayEvents, paramters.timeZone);
    return icsElements;
  } catch (error) {
    console.error('Error processing ICS file:', error);
  }
}

function getEventsForToday(events, timeZone) {
  const { todayStart, todayEnd } = getTodayStartAndEndInTimeZone(timeZone);

  const processedUIDs = new Set();

  const filteredEvents = events
    .map(event => {
      const dtstartKey = Object.keys(event).find(key => key.startsWith('DTSTART'));
      const start = parseToDate(event, dtstartKey);
      if (start) {
        event['DTSTART'] = start; // Ensure UTC format
      }

      const dtendKey = Object.keys(event).find(key => key.startsWith('DTEND'));
      const end = parseToDate(event, dtendKey);
      if (end) {
        event['DTEND'] = end; // Ensure UTC format
      }

      //Mei 2025-12-10 EXDATE
      const exdatesKey = Object.keys(event).find(key => key.startsWith('EXDATE'));
      if(exdatesKey){
        //console.log('exdatesKey is : ' + exdatesKey);
        //console.log('exdatesKey value is : ' + event[exdatesKey]);
        event['EXDATE'] = parseEXDATEToDate(event, exdatesKey);
        //console.log('after exdatesKey value is : ' + event['EXDATE']);
      }
      event['displayTZ'] = timeZone;
      if (event['RRULE'] && !processedUIDs.has(event['UID'])) {
        const nextOccurrence = getNextOccurrence(event, todayStart);
        if (nextOccurrence) {
          event['NEXT_OCCURRENCE'] = nextOccurrence; // Ensure UTC format
          const duration = event['DTEND'] && event['DTSTART']
            ? event['DTEND'].getTime() - event['DTSTART'].getTime()
            : 3600000;
          const endTime = new Date(new Date(nextOccurrence).getTime() + duration);
          event['DTEND'] = endTime; // Ensure UTC format
          processedUIDs.add(event['UID']);
        }
      }

      return event;
    })
    .filter(event => {
      const start = event['NEXT_OCCURRENCE'] || event['DTSTART'];
      const startUTC = start.getTime(); // Convert to timestamp for comparison
      return ((startUTC >= todayStart.getTime() && startUTC < todayEnd.getTime()) || 
              (startUTC < todayStart.getTime() && event['DTEND'].getTime() > todayStart.getTime()));
    });
  /**
   * Mei 2025-12-23
   * Filter RECURRENCE-ID events, 
   * If today's event is a recurring event, and include a RECURRENCE-ID event,
   * we should show the RECURRENCE-ID event and hide the original event
   */
  const finalFilteredEvents = filteredEvents.filter(event => {
    if (event['RRULE']) {
      const recurrenceID = filteredEvents.filter(e => e['RECURRENCE-ID'] && (e['UID'] === event['UID']));
      return recurrenceID.length > 0 ? false : true;
    }
    return true;
  });
  return finalFilteredEvents.sort((a, b) => {
    const aTime = a['NEXT_OCCURRENCE'] || a['DTSTART'];
    const bTime = b['NEXT_OCCURRENCE'] || b['DTSTART'];
    return aTime.getTime() - bTime.getTime();
  });
}
//For testing
//const todayDate = new Date(2026, 6, 27, 13, 10, 0);
function getTodayStartAndEndInTimeZone(timeZone) {
  const now = new Date();//todayDate;

  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false
  });

  const parts = formatter.formatToParts(now);
  const year = parseInt(parts.find(part => part.type === 'year').value, 10);
  const month = parseInt(parts.find(part => part.type === 'month').value, 10) - 1; // JavaScript 的月份从 0 开始
  const day = parseInt(parts.find(part => part.type === 'day').value, 10);
  const hour = parseInt(parts.find(part => part.type === 'hour').value, 10);
  const minute = parseInt(parts.find(part => part.type === 'minute').value, 10);
  const second = parseInt(parts.find(part => part.type === 'second').value, 10);

  const offsetMinutes = getTimeZoneOffset(timeZone);
  const timeZoneNow = new Date(Date.UTC(year, month, day, hour, minute, second) - offsetMinutes * 60 * 1000);
  const timeZoneEndOfDay = new Date(Date.UTC(year, month, day, 23, 59, 59, 999) - offsetMinutes * 60 * 1000);

  const todayStart = new Date(timeZoneNow.getTime());
  const todayEnd = new Date(timeZoneEndOfDay.getTime());

  return { todayStart, todayEnd };
}

function getNextOccurrence(event, currentDate) {
  const dtstart = new Date((event["DTSTART"]).getTime());
  const rrule = event['RRULE'];
  //Before already parsed EXDATE to date array
  const exdates = event['EXDATE'] ? event['EXDATE']/*.split(',').map(date => new Date(date.trim()))*/ : [];

  if (!rrule) {
    return dtstart >= currentDate ? dtstart : null;
  }

  const rule = parseRRule(rrule, dtstart);
  return getNextDateFromRule(event, rule, currentDate, exdates);
}

function parseRRule(rrule, dtstart) {
  const rule = {};
  const parts = rrule.split(';');
  parts.forEach(part => {
    const [key, value] = part.split('=');
    rule[key] = value;
  });

  rule['DTSTART'] = dtstart;
  return rule;
}

function getNextDateFromRule(event, rule, currentDate, exdates = []) {
  const freq = rule['FREQ'];
  const dtstart = rule['DTSTART'];
  const interval = parseInt(rule['INTERVAL'] || '1', 10);
  const until = rule['UNTIL'] ? parseToDate({ UNTIL: rule['UNTIL'] }, 'UNTIL') : null;
  const byDay = rule['BYDAY'] ? rule['BYDAY'].split(',') : null;

  let nextDate = dtstart;
  //Mei 2025-12-16 adjust expiration date check
  if (until && until < currentDate) {
    return null;
  }
  console.log(`getNextDateFromRule called with meeting  MeetingName: ${event['SUMMARY']}, UID: ${event['UID']} freq: ${freq}, dtstart: ${dtstart}, interval: ${interval}, until: ${until}, byDay: ${byDay}, currentDate: ${currentDate}, exdates: ${exdates}`);
  while (nextDate < currentDate || exdates.some(exdate => exdate.getTime() === nextDate.getTime())) {
    if (freq === 'DAILY') {
      nextDate.setUTCDate(nextDate.getUTCDate() + interval);
    } else if (freq === 'WEEKLY') {
      return getNextDateFromRuleForWeekly(event, rule, currentDate, exdates); 
    } else if (freq === 'MONTHLY') {
      nextDate.setUTCMonth(nextDate.getUTCMonth() + interval);
    } else if (freq === 'YEARLY') {
      nextDate.setUTCFullYear(nextDate.getUTCFullYear() + interval);
    }

    if (byDay && !matchesByDay(nextDate, byDay)) {
      continue;
    }

    if (until && nextDate > until) {
      return null;
    }
  }

  return nextDate;
}

function getNextDateFromRuleForWeekly(event, rule, currentDate, exdates = []) {
  const interval = parseInt(rule['INTERVAL'] || '1', 10);
  const until = rule['UNTIL'] ? parseToDate({ UNTIL: rule['UNTIL'] }, 'UNTIL') : null;
  const byDay = rule['BYDAY'] ? rule['BYDAY'].split(',') : null;

  const meetingTZ = event['meetingTZ'];
  const displayTZ = event['displayTZ'];

  const meetingOffset = getTimeZoneOffset(meetingTZ);
  const displayOffset = getTimeZoneOffset(displayTZ);

  const duration = event['DTEND'] && event['DTSTART']
    ? event['DTEND'].getTime() - event['DTSTART'].getTime()
    : 3600000;

  //Convert DTSTART to meeting time zone
  let dtstart = new Date(rule['DTSTART'].getTime() + meetingOffset * 60* 1000);

  //Convert currentDate to the meeting time zone.
  const currentInMeetingTZ = new Date(currentDate.getTime() + meetingOffset * 60 * 1000);

  //UNTIL: Convert meeting time zone
  const untilInMeetingTZ = until ? new Date(until.getTime() + meetingOffset * 60000) : null;
  console.log(`meetingTZ: ${event['meetingTZ']}, displayTZ: ${event['displayTZ']}, meetingOffset: ${meetingOffset}, displayOffset: ${displayOffset}`);
  console.log(`Meeting time in the meeting time zone: dtstart: ${dtstart}(${dtstart.toLocaleString()}), currentInMeetingTZ:${currentInMeetingTZ}(${currentInMeetingTZ.toLocaleString()})`);
  //If it has already expired
  if (untilInMeetingTZ && currentInMeetingTZ > untilInMeetingTZ) {
    return null;
  }

  // WEEKLY
  let nextDate = new Date(dtstart);
  console.log(`nextDate: ${nextDate} `)
  while (true) {
    if( new Date(nextDate.getTime() - meetingOffset * 60* 1000 /*+ displayOffset * 60 * 1000*/) > currentDate){
      console.log(` nextDate ${nextDate} bigger than currentDate ${currentDate}`)
        break;
    }
    //Find the start date of the week containing 'nextDate' (based on the meeting time zone).
    const weekStart = getWeekStartInMeetingTZ(nextDate, rule['WKST'] || "SU");
    //Calculate the difference in weeks between currentDate and weekStart.
    const weeksBetween = Math.floor((currentInMeetingTZ - weekStart) / (7 * 24 * 3600 * 1000));
    const isValidWeek = (weeksBetween % interval === 0);
    if (isValidWeek && byDay) {
      //Generate the meeting timezone dates for all BYDAYs of the week.
      const candidateMeetingDates = byDay.map(day =>
        getDateForWeekdayInMeetingTZ(weekStart, day, dtstart)
      );
      //console.log(`getNextDateFromRule: candidateMeetingDates: ${candidateMeetingDates.map(d => d)}`); 
      //console.log(`getNextDateFromRule: candidateMeetingDates to localstring: ${candidateMeetingDates.map(d => d.toLocaleString())}`);

      //Convert to UTC.
      const candidateLocalDates = candidateMeetingDates.map(d =>
        new Date(d.getTime() - meetingOffset * 60* 1000 /*+ displayOffset * 60 * 1000*/)
      );
      //console.log(`getNextDateFromRule: candidateLocalDates: ${candidateLocalDates.map(d => d)}`); 
      //console.log(`getNextDateFromRule: candidateLocalDates to localstring: ${candidateLocalDates.map(d => d.toLocaleString())}`);
      //Find the next meeting on or after the current date(>=  currentDate).
      for (let i = 0; i < candidateLocalDates.length; i++) {
        const dLocal = candidateLocalDates[i];
        //const dMeeting = candidateMeetingDates[i];
        const endTime = new Date(dLocal.getTime() + duration);
        if ((dLocal >= currentDate || (dLocal < currentDate && endTime > currentDate)) &&
            !exdates.some(ex => ex.getTime() === dLocal.getTime())) {

          //Return the meeting time in the UTC time zone.
          console.log(` dLocal = ${dLocal} `)
          return dLocal;
        }
      }
    }

    //Jump to the next week that matches the INTERVAL (meeting time zone)
    nextDate = new Date(weekStart.getTime() + interval * 7 * 24 * 3600 * 1000);
    //console.log(` 111 nextDate = ${nextDate} `)
    //Exceeding UNTIL
    if (untilInMeetingTZ && nextDate > untilInMeetingTZ) {
      return null;
    }
  }

  return null;
}

function matchesByDay(date, byDay) {
  const days = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];
  const day = days[date.getUTCDay()];
  return byDay.includes(day);
}

function getWeekStartInMeetingTZ(dateInMeetingTZ, wkst, meetingTZ) {
  const days = ['SU','MO','TU','WE','TH','FR','SA'];
  const startIndex = days.indexOf(wkst);
  const currentIndex = dateInMeetingTZ.getUTCDay();
  const diff = (currentIndex - startIndex + 7) % 7;
  const start = new Date(dateInMeetingTZ);
  //start.setDate(dateInMeetingTZ.getDate() - diff);
  start.setUTCDate(dateInMeetingTZ.getUTCDate() - diff);

  return start;
}

function getDateForWeekdayInMeetingTZ(weekStartInMeetingTZ, weekday) {
  const days = ['SU','MO','TU','WE','TH','FR','SA'];
  const index = days.indexOf(weekday);

  const d = new Date(weekStartInMeetingTZ);
  //d.setDate(weekStartInMeetingTZ.getDate() + index);
  d.setUTCDate(weekStartInMeetingTZ.getUTCDate() + index);
  //console.log(`getDateForWeekdayInMeetingTZ: weekStartInMeetingTZ: ${weekStartInMeetingTZ}, weekday: ${weekday}, index: ${index}, result date: ${d}`);  
  return d;
}

function createStyledDateElement(todayEvents, timeZone) {
  const outerContainer = document.createElement('div');
  outerContainer.classList.add('outer-container');

  const eventElement = document.createElement('div');
  eventElement.classList.add('event-container');
  const todayDate = new Date();
  const dayElement = document.createElement('div');
  dayElement.classList.add('event-day');
  dayElement.textContent = todayDate.toLocaleDateString('en-US', { timeZone, weekday: 'long' });

  const dateContainer = document.createElement('div');
  dateContainer.classList.add('event-date-container');

  const dateNumber = document.createElement('div');
  dateNumber.classList.add('event-date-number');
  dateNumber.textContent = todayDate.toLocaleDateString('en-US', { timeZone, day: '2-digit' });

  const dateDetails = document.createElement('div');
  dateDetails.classList.add('event-date-details');

  const detailText = document.createElement('div');
  detailText.classList.add('event-detail-text');
  detailText.textContent = todayDate.toLocaleDateString('en-US', { timeZone, month: 'long' });

  const yearText = document.createElement('div');
  yearText.classList.add('event-year-text');
  yearText.textContent = todayDate.toLocaleString('en-US', { timeZone, year: 'numeric' });

  dateDetails.appendChild(detailText);
  dateDetails.appendChild(yearText);
  dateContainer.appendChild(dateNumber);
  dateContainer.appendChild(dateDetails);

  eventElement.appendChild(dayElement);
  eventElement.appendChild(dateContainer);

  const upcomingTitle = document.createElement('div');
  upcomingTitle.classList.add('upcoming-title');
  upcomingTitle.textContent = 'Upcoming:';

  outerContainer.appendChild(eventElement);
  outerContainer.appendChild(upcomingTitle);

  const eventsContainer = createEventElements(todayEvents, timeZone);
  outerContainer.appendChild(eventsContainer);

  return outerContainer;
}

function createEventElements(todayEvents, timeZone) {
  const eventsContainer = document.createElement('div');
  eventsContainer.classList.add('events-container');

  todayEvents.forEach(event => {
    const eventElement = document.createElement('div');
    eventElement.classList.add('event-toaster');

    const contentContainer = document.createElement('div');
    contentContainer.classList.add('event-content');

    const summaryElement = document.createElement('div');
    summaryElement.classList.add('event-summary');
    summaryElement.textContent = event.SUMMARY || 'No Title';

    const timeElement = document.createElement('div');
    timeElement.classList.add('event-time');
    const timeOptions = {
      timeZone, // Ensure the time is displayed in the specified timeZone
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    };

    const startTime = event.NEXT_OCCURRENCE
      ? new Date(event.NEXT_OCCURRENCE).toLocaleTimeString('en-US', timeOptions)
      : event.DTSTART
        ? new Date(event.DTSTART).toLocaleTimeString('en-US', timeOptions)
        : 'N/A';

    const endTime = event.DTEND
      ? new Date(event.DTEND).toLocaleTimeString('en-US', timeOptions)
      : 'N/A';
      
    timeElement.textContent = `${startTime} - ${endTime}`;
    contentContainer.appendChild(summaryElement);
    contentContainer.appendChild(timeElement);
    eventElement.appendChild(contentContainer);
    eventsContainer.appendChild(eventElement);
  });

  return eventsContainer;
}

async function fetchICSFile(icsUrl) {
  try {
    const proxyUrl = new URL(backEndAPIAddrForCalendarIcs);
    proxyUrl.searchParams.set(`icsUrl`, icsUrl);
    proxyUrl.searchParams.set(`t`, Date.now());
    const response = await fetch(proxyUrl.toString());
    const icsData = await response.text();
    return icsData;
  } catch (error) {
    console.error('Error fetching ICS file:', error);
    throw error;
  }
}

function parseICS(icsData, isGoogleCalendar) {
  const events = [];
  const lines = icsData.split(/\r?\n/);
  let currentEvent = null;
  let lastline = '';

  for (let line of lines) {
    /**
     * Mei 2025.12.5
     * ics file: 
     * Handle folded lines (lines that start with space or tab are continuations of the previous line)
     */  
    if (line && (line.startsWith(' ') || line.startsWith('\t'))) {
      line = lastline + line.trim();
    } else {
      lastline = line;
    }
    if (line.startsWith('BEGIN:VEVENT')) {
      currentEvent = {};
    } else if (line.startsWith('END:VEVENT')) {
      if (currentEvent) {
        events.push(currentEvent);
        currentEvent = null;
      }
    } else if (currentEvent) {
      const [key, value] = line.split(/:(.+)/);
      if (key && value) {
        // Normalize keys for Google Calendar
        if (isGoogleCalendar && key === 'DTSTART;VALUE=DATE') {
          currentEvent['DTSTART'] = value;
        } else if (isGoogleCalendar && key === 'DTEND;VALUE=DATE') {
          currentEvent['DTEND'] = value;
        } else {
          currentEvent[key] = value;
        }
      }
    }
  }

  return events;
}

function parseToDate(event, key) {
  const dtValue = event[key];
  if (!dtValue) return null;
  const timeZoneMatch = key.match(/TZID=([^:;]+)/);
  let originalTimeZone = timeZoneMatch ? timeZoneMatch[1] : 'Etc/UTC';

  // Map Microsoft time zones to IANA time zones
  if (TimeZoneMapper.timeZoneMap[originalTimeZone]) {
    originalTimeZone = TimeZoneMapper.timeZoneMap[originalTimeZone];
  }
  
  const cleanDate = dtValue.replace(/TZID=[^:]+:/, '');
  if (dtValue.endsWith('Z')) {
    originalTimeZone = 'Etc/UTC';
  }
  const year = parseInt(cleanDate.slice(0, 4), 10);
  const month = parseInt(cleanDate.slice(4, 6), 10) - 1; 
  const day = parseInt(cleanDate.slice(6, 8), 10);
  const hour = cleanDate.length > 8 ? parseInt(cleanDate.slice(9, 11), 10) : 0;
  const minute = cleanDate.length > 10 ? parseInt(cleanDate.slice(11, 13), 10) : 0;
  const second = cleanDate.length > 12 ? parseInt(cleanDate.slice(13, 15), 10) : 0;
  const localDate = new Date(Date.UTC(year, month, day, hour, minute, second));
  const offset = getTimeZoneOffset(originalTimeZone);
  const utcDate = new Date(localDate.getTime() - offset * 60 * 1000);

  event['meetingTZ']=originalTimeZone;
  return utcDate;
}

function parseEXDATEToDate(event, key) {
  const dtValue = event[key];
  if (!dtValue) return null;
  const timeZoneMatch = key.match(/TZID=([^:;]+)/);
  let originalTimeZone = timeZoneMatch ? timeZoneMatch[1] : 'Etc/UTC';

  // Map Microsoft time zones to IANA time zones
  if (TimeZoneMapper.timeZoneMap[originalTimeZone]) {
    originalTimeZone = TimeZoneMapper.timeZoneMap[originalTimeZone];
  }
  
  const cleanDate = dtValue.replace(/TZID=[^:]+:/, '');
  const exdateList = cleanDate.split(',').map(dateStr => {
    if (dateStr.endsWith('Z')) {
      originalTimeZone = 'Etc/UTC';
    }
    const year = parseInt(dateStr.slice(0, 4), 10);
    const month = parseInt(dateStr.slice(4, 6), 10) - 1; 
    const day = parseInt(dateStr.slice(6, 8), 10);
    const hour = dateStr.length > 8 ? parseInt(dateStr.slice(9, 11), 10) : 0;
    const minute = dateStr.length > 10 ? parseInt(dateStr.slice(11, 13), 10) : 0;
    const second = dateStr.length > 12 ? parseInt(dateStr.slice(13, 15), 10) : 0;
    const localDate = new Date(Date.UTC(year, month, day, hour, minute, second));
    const offset = getTimeZoneOffset(originalTimeZone);
    const utcDate = new Date(localDate.getTime() - offset * 60 * 1000);
    return utcDate;
  });
  return exdateList ? exdateList : null;
}

function getTimeZoneOffset(timeZone) {
  const now = new Date();
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone,
    timeZoneName: 'shortOffset',
  });

  const parts = formatter.formatToParts(now);
  const timeZonePart = parts.find(part => part.type === 'timeZoneName');

  if (timeZonePart) {
    if(timeZonePart.value === 'GMT'){
      console.log(`getTimeZoneOffset: timeZone is UTC`);
      return 0;
    }
    const offsetMatch = timeZonePart.value.match(/([+-]\d{1,2}):?(\d{2})?/);
    if (offsetMatch) {
      const hours = parseInt(offsetMatch[1], 10);
      const minutes = parseInt(offsetMatch[2] || '0', 10);
      return hours * 60 + (hours < 0 ? -minutes : minutes); 
    }
  }

  const localTime = new Date(now.toLocaleString('en-US', { timeZone }));
  return (now.getTime() - localTime.getTime()) / (1000 * 60); 
}

const TimeZoneMapper = {
  timeZoneMap: {
    "Samoa Standard Time": "Pacific/Pago_Pago",
    "Hawaiian Standard Time": "Pacific/Honolulu",
    "Alaskan Standard Time": "America/Anchorage",
    "Pacific Standard Time": "America/Los_Angeles",
    "Mountain Standard Time": "America/Denver",
    "Mexico Standard Time 2": "America/Denver",
    "US Mountain Standard Time": "America/Denver",
    "Central Standard Time": "America/Chicago",
    "Canada Central Standard Time": "America/Chicago",
    "Mexico Standard Time": "America/Chicago",
    "Central America Standard Time": "America/Chicago",
    "Eastern Standard Time": "America/New_York",
    "US Eastern Standard Time": "America/New_York",
    "South America Pacific Standard Time": "America/New_York",
    "Atlantic Standard Time": "America/Halifax",
    "South America Western Standard Time": "America/Halifax",
    "Pacific South America Standard Time": "America/Halifax",
    "Newfoundland and Labrador Standard Time": "America/St_Johns",
    "East South America Standard Time": "America/Argentina/Buenos_Aires",
    "South America Eastern Standard Time": "America/Argentina/Buenos_Aires",
    "Greenland Standard Time": "America/Argentina/Buenos_Aires",
    "Azores Standard Time": "Atlantic/Azores",
    "Cape Verde Standard Time": "Atlantic/Azores",
    "Central Europe Standard Time": "Europe/Amsterdam",
    "Central European Standard Time": "Europe/Amsterdam",
    "Romance Standard Time": "Europe/Amsterdam",
    "West Europe Standard Time": "Europe/Amsterdam",
    "West Central Africa Standard Time": "Europe/Amsterdam",
    "East Europe Standard Time": "Africa/Cairo",
    "Egypt Standard Time": "Africa/Cairo",
    "FLE Standard Time": "Africa/Cairo",
    "GTB Standard Time": "Africa/Cairo",
    "Israel Standard Time": "Africa/Cairo",
    "South Africa Standard Time": "Africa/Cairo",
    "Russian Standard Time": "Europe/Moscow",
    "Arab Standard Time": "Europe/Moscow",
    "East Africa Standard Time": "Europe/Moscow",
    "Arabic Standard Time": "Europe/Moscow",
    "Iran Standard Time": "Asia/Tehran",
    "Arabian Standard Time": "Asia/Dubai",
    "Caucasus Standard Time": "Asia/Dubai",
    "Transitional Islamic State of Afghanistan Standard Time": "Asia/Kabul",
    "Ekaterinburg Standard Time": "Asia/Karachi",
    "West Asia Standard Time": "Asia/Karachi",
    "India Standard Time": "Asia/Kolkata",
    "Nepal Standard Time": "Asia/Kathmandu",
    "Central Asia Standard Time": "Asia/Dhaka",
    "Sri Lanka Standard Time": "Asia/Dhaka",
    "North Central Asia Standard Time": "Asia/Dhaka",
    "Myanmar Standard Time": "Asia/Rangoon",
    "SouthEast Asia Standard Time": "Asia/Bangkok",
    "South East Asia Standard Time": "Asia/Bangkok",
    "North Asia Standard Time": "Asia/Bangkok",
    "China Standard Time": "Asia/Shanghai",
    "Singapore Standard Time": "Asia/Shanghai",
    "Taipei Standard Time": "Asia/Shanghai",
    "West Australia Standard Time": "Asia/Shanghai",
    "North Asia East Standard Time": "Asia/Shanghai",
    "Korea Standard Time": "Asia/Tokyo",
    "Tokyo Standard Time": "Asia/Tokyo",
    "Yakutsk Standard Time": "Asia/Tokyo",
    "AUS Central Standard Time": "Australia/Adelaide",
    "Cen. Australia Standard Time": "Australia/Adelaide",
    "AUS Eastern Standard Time": "Australia/Sydney",
    "East Australia Standard Time": "Australia/Sydney",
    "Tasmania Standard Time": "Australia/Sydney",
    "Vladivostok Standard Time": "Australia/Sydney",
    "West Pacific Standard Time": "Australia/Sydney",
    "Central Pacific Standard Time": "Pacific/Guadalcanal",
    "Fiji Islands Standard Time": "Pacific/Auckland",
    "New Zealand Standard Time": "Pacific/Auckland",
    "Tonga Standard Time": "Pacific/Apia",
    "Greenwich Standard Time": "Etc/UTC",
    "GMT Standard Time": "Etc/UTC",
  },

  getIanaTimeZone(msTimeZone) {
    const normalizedTimeZone = msTimeZone
      .replace(/A\.U\.S\./g, "AUS")
      .replace(/U\.S\./g, "US")
      .replace(/S\.A\./g, "South America")
      .replace(/N\./g, "North")
      .replace(/E\./g, "East")
      .replace(/W\./g, "West")
      .replace(/S\./g, "South");

    return this.timeZoneMap[normalizedTimeZone] || "Etc/UTC";
  },
};
